import {WlCheckbox} from "./checkbox";

export * from './checkbox.component';
export default WlCheckbox;

customElements.define('wl-checkbox', WlCheckbox);
